exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nhtml,\nbody,\nheader,\n.view {\n  height: 105%;\n}\n/* Navigation*/\n\n.navbar {\n  background-color: transparent;\n}\n\n.top-nav-collapse {\n  background-color: #0e006d;\n}\n\n@media only screen and (max-width: 768px) {\n  .navbar {\n    background-color: #1C2331;\n  }\n}\n/*Intro*/\n\n@media (min-width: 768px) {\n  .view {\n    overflow: visible;\n    margin-top: -54px;\n  }\n}\n\nbody {\n  background-color: #ebebeb;\n}\n\n.view {\n  background-image: url(\"/assets/img/yatches/landing001.jpg\");\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-attachment: fixed;\n  background-size: cover;\n\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/styles.css
// module id = 190
// module chunks = 2